import { render, staticRenderFns } from "./_favoriteButton.vue?vue&type=template&id=570b9c4b&"
import script from "./_favoriteButton.vue?vue&type=script&lang=js&"
export * from "./_favoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('570b9c4b', component.options)
    } else {
      api.reload('570b9c4b', component.options)
    }
    module.hot.accept("./_favoriteButton.vue?vue&type=template&id=570b9c4b&", function () {
      api.rerender('570b9c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ActionToolbar/Scripts/Buttons/_favoriteButton.vue"
export default component.exports